const tabTitleButtons = document.querySelectorAll('.Tabs-title button');
const tabContents = document.querySelectorAll('.Tabs-content');

let tabIndex = 0;

tabTitleButtons.forEach((tabTitleButton, i) => {
  tabTitleButton.addEventListener('click', () => {
    [...tabTitleButtons, ...tabContents].forEach((el) => {
      el.classList.remove('active');
      // eslint-disable-next-line no-param-reassign
      el.hidden = true;
      if (el.ariaExpanded === 'true') {
        // eslint-disable-next-line no-param-reassign
        el.ariaExpanded = 'false';
        // eslint-disable-next-line no-param-reassign
        el.ariaSelected = 'false';
      }
    });
    const tabContent = tabContents[i];
    [tabTitleButton, tabContent].forEach((el) => {
      el.classList.add('active');
      // eslint-disable-next-line no-param-reassign
      el.hidden = false;
    });
    // eslint-disable-next-line no-param-reassign
    tabTitleButton.ariaExpanded = 'true';
    // eslint-disable-next-line no-param-reassign
    tabTitleButton.ariaSelected = 'true';
  });
});

const focusOn = (index) => {
  const tab = tabTitleButtons[index];
  if (tab !== undefined) {
    tab.focus();
  }
};

tabTitleButtons.forEach((tab, i) => {
  tab.addEventListener('keydown', (e) => {
    const key = e.code;

    if (key === 'ArrowRight') {
      focusOn(i + 1);
      tabIndex += 1;

      if (tabIndex >= tabTitleButtons.length) {
        focusOn(i - 1);
        tabIndex = 0;
      }
    }

    if (key === 'ArrowLeft') {
      focusOn(i - 1);
      tabIndex -= 1;

      if (tabIndex < 0) {
        focusOn(i + 1);
        tabIndex = 0;
      }
    }
  });
});
